<template>
  <div class="summary-control">
    <p class="header">{{ t('summary_control.general_information') }}</p>
    <div class="badge-container">
      <div class="badge-row">
        <div class="badge" :class="{ 'active-blue': dataStore.isSaveBTNclickedonce && dataStore.recordsAnalyzed }">
          <div class="label">{{ t('summary_control.records_analyzed') }}</div>
          <div class="value">{{ dataStore.recordsAnalyzed || "-" }}</div>
        </div>
        <div class="badge" :class="{ 'active-blue': dataStore.isSaveBTNclickedonce && dataStore.totalAmount }">
          <div class="label">{{ t('summary_control.total_amount') }}</div>
          <div class="value" v-if="dataStore.totalAmount !== 0">{{ '€ ' + formatTotalAmount(dataStore.totalAmount) }}</div>
          <div class="value" v-else>-</div>
        </div>
      </div>
      <div class="badge-row">
        <div class="badge" :class="{ 'active-red': dataStore.isSaveBTNclickedonce && dataStore.journalErrorcount }">
          <div class="label">{{ t('summary_control.journal_errors') }}</div>
          <div class="value">{{ dataStore.journalErrorcount || "-" }}</div>
        </div>
        <div class="badge" :class="{ 'active-red': dataStore.isSaveBTNclickedonce && dataStore.logErrorcount }">
          <div class="label">{{ t('summary_control.log_errors') }}</div>
          <div class="value">{{ dataStore.logErrorcount || "-" }}</div>
        </div>
      </div>
    </div>
    <div class="file-safe-container">
      <div class="file-safe-text">{{ t('summary_control.save_text') }}</div>
      <div
        :class="{ 'file-safe-disabled': !dataStore.isSaveBTNclickedonce, 'file-safe-enabled': dataStore.isSaveBTNclickedonce }"
        @click="dataStore.downloadFile()">
        DOWNLOAD
      </div>
    </div>
  </div>
</template>

<script setup>
import { useDataStore } from '@/stores/dataStore.js';
import { useI18n } from 'vue-i18n'

const { t } = useI18n();
const dataStore = useDataStore();

const formatTotalAmount = (amount) => {
  return Number(amount).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}
</script>

<style scoped>
.header {
  color: var(--text-primary-color);
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 10px;
  margin: 0;
}

.summary-control {
  border-radius: 10px;
  background-color: var(--background-color-secondary);
  padding: 30px;
}

.badge-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-weight: 600;
}

.badge-row {
  display: flex;
  gap: 10px;
}

.badge {
  flex: 0 1 50%;
  background-color: var(--badge-disabled-background-color);
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  color: var(--badge-disabled-text-color);
  padding: 11px 18px;
}

.file-safe-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
  margin: 30px;
  align-items: center;
  margin-bottom: 0px;
}

.file-safe-enabled {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
  height: 36px;
  width: 109px;
  background-color: var(--save-button-enabled-background-color);
  color: var(--save-button-enabled-text-color);
  line-height: 15px;
  font-weight: 700;
  font-size: 13px;
}

.file-safe-disabled {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  cursor: none;
  border-radius: 5px;
  height: 36px;
  width: 109px;
  background-color: var(--save-button-disabled-background-color);
  color: var(--save-button-disabled-text-color);
  line-height: 15px;
  font-weight: 700;
  font-size: 13px;
}

.file-safe-text {
  color: var(--text-primary-color);
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
}

.active-blue {
  background-color: var(--active-blue-background-color);
  color: var(--active-blue-text-color);
}

.active-red {
  background-color: var(--active-red-background-color);
  color: var(--active-red-text-color);
}

.value {
  font-size: 20px;
  margin-top: 5px;
}
</style>
